import { render, staticRenderFns } from "./DialogCadastro.vue?vue&type=template&id=3f684f58&scoped=true"
import script from "./DialogCadastro.vue?vue&type=script&lang=js"
export * from "./DialogCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f684f58",
  null
  
)

export default component.exports